import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import { linkProps } from "../lib/navLink.jsx";

/**
 * Contained rounded CTA banner — dark gradient card with rounded 1.25rem corners.
 * section props: kicker, title, body, primaryCtaLabel, primaryCtaHref,
 *                secondaryCtaLabel, secondaryCtaHref,
 *                variant: "default" | "success" | "dark"
 */
export default function FeatureBanner({ section }) {
  if (!section?.title) return null;
  const {
    kicker,
    title,
    body,
    primaryCtaLabel,
    primaryCtaHref,
    secondaryCtaLabel,
    secondaryCtaHref,
    variant,
  } = section;

  const variantClass =
    variant === "success"
      ? " pmp-feature-banner--success"
      : variant === "dark"
        ? " pmp-feature-banner--dark"
        : "";

  return (
    <section className="pmp-feature-banner-section">
      <Container>
        <div className={`pmp-feature-banner${variantClass}`}>
          <Row className="align-items-center g-4">
            <Col lg={8}>
              {kicker && (
                <p
                  className="pmp-kicker mb-2"
                  style={{ color: "rgba(255,255,255,0.5)" }}
                >
                  {kicker}
                </p>
              )}
              <h2 className="mb-2">{title}</h2>
              {body && <p className="mb-0 fs-6">{body}</p>}
            </Col>
            <Col
              lg={4}
              className="d-flex gap-3 flex-wrap justify-content-lg-end"
            >
              {primaryCtaLabel && (
                <Button
                  variant="success"
                  {...linkProps(primaryCtaHref, { fallback: "#" })}
                  className="px-4"
                >
                  {primaryCtaLabel}
                </Button>
              )}
              {secondaryCtaLabel && (
                <Button
                  variant="outline-light"
                  {...linkProps(secondaryCtaHref, { fallback: "#" })}
                  className="px-4"
                >
                  {secondaryCtaLabel}
                </Button>
              )}
            </Col>
          </Row>
        </div>
      </Container>
    </section>
  );
}
